import React, { useState, useEffect } from 'react'
import { XBlock, XMasonry } from 'react-xmasonry'
import { IGatsbyImageData } from 'gatsby-plugin-image'
import MainMedia from '../firm/mainMedia'
import Description from '../../ui/description'
import TeamEssentials from './essentials'
import Wrapper from '../../ui/wrapper'
import { SocialsWrapper } from '../firm/socials/socialsWrapper'
import { Team } from '../firm/mapper'
import { ModalWithMedias } from '../../ui/medias/ModalWithMedia'

type TeamProps = {
  team: Team
  youTubeApiKey: string | null
  color: string | null
}

type MediaItem = {
  id: string | null
  media: string | IGatsbyImageData
  video: boolean
  key: string
} | null

const TeamTemplate: React.FC<TeamProps> = ({ team, youTubeApiKey, color }) => {
  const [isDataFormated, setIsDataFormated] = useState(false)
  const [teamMediaData, setMediaTeamData] = useState<MediaItem[] | null>(null)
  const hasSocial =
    Boolean(team?.socials?.facebook ||
      team?.socials?.instagram ||
      team?.socials?.linkedin ||
      team?.socials?.twitter ||
      team?.socials?.youtube)

  useEffect(() => {
    if (team && team.medias) {
      let teamMedias: MediaItem[] | null = []
      teamMedias = team.medias.map((media, index) => {
        if (media && media.media) {
          return {
            id: media.id,
            media: media.media,
            video: media.video,
            key: `teamMedia-${index}-${team.name}`,
          }
        }
        return null
      })
      teamMedias = teamMedias
        ? teamMedias.filter(Boolean)
        : null
      teamMedias?.shift()
      setMediaTeamData(teamMedias)
      setIsDataFormated(true)
    }
  }, [])

  return (
    <div className="container justify-center mx-auto mt-8">
      <XMasonry maxColumns={4} updateOnImagesLoad responsive smartUpdate>
        {team && team.mainMedia && team?.medias && team?.medias?.length > 0 && (
          <XBlock width={2}>
            <div className="masonry-block">
              <MainMedia
                id={team?.mainMedia?.id}
                mainMedia={team?.mainMedia}
                name={team?.name}
                youTubeApiKey={youTubeApiKey}
              />
            </div>
          </XBlock>
        )}
        <XBlock width={2}>
          {team && team.description && (
            <div className="masonry-block">
              <Description data={team.description} label="Qui sommes nous ?" />
            </div>
          )}
        </XBlock>
        <XBlock width={1}>
          <div className="masonry-block">
            <TeamEssentials
              foundedYear={team?.foundedYear || null}
              employeeAgeAverage={team?.employeeAgeAverage || null}
              totalEmployees={team?.totalEmployees || null}
              color={color || null}
            />
          </div>
        </XBlock>
        {isDataFormated &&
          teamMediaData &&
          teamMediaData.length > 0 &&
          teamMediaData.map((media) => (
            <XBlock width={1} key={media?.key}>
              {team && media && (
                <div className="masonry-block">
                  <ModalWithMedias
                    id={media.id}
                    media={media.media}
                    name={team.name ?? ''}
                    video={media?.video}
                    youTubeApiKey={youTubeApiKey}
                  />
                </div>
              )}
            </XBlock>
          ))}
        {hasSocial && (
          <XBlock width={1}>
            <div className="masonry-block">
              <Wrapper>
                <SocialsWrapper socials={team?.socials} color={color} />
              </Wrapper>
            </div>
          </XBlock>
        )}
      </XMasonry>
    </div>
  )
}

export default TeamTemplate
